import { Component, Inject, Input, OnInit ,AfterViewInit} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ViewChild, ElementRef } from '@angular/core';

declare var google:any;
declare var document:any;
declare var map:any;
@Component({
  selector: 'app-edit-stop-of-task',
  templateUrl: './edit-stop-of-task.component.html',
  styleUrls: ['./edit-stop-of-task.component.css']
})
export class EditStopOfTaskComponent implements OnInit,AfterViewInit {
  @ViewChild('inputField') inputField!: ElementRef;
  taskDetails: any;
  pickLocation:any;
  isPickup:boolean;
  contact:any;
  date:any;
  client:any;
  description:any;
  taskid:any

  @Input() placeholder = '';
  autocomplete: google.maps.places.Autocomplete;
  disabled: boolean = true;
   lat:any;
   long:any;
   map:any=null
  selectedValue: string;
  driverForm: FormGroup;
  formattedDate: string;

  isDrop: boolean;
  

  constructor(
    public dialogRef: MatDialogRef<EditStopOfTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private commonService:CommonService,
    private fb:FormBuilder
  ) { 
    this.taskDetails = data;
   
  }

  ngOnInit(): void {
  if(this.taskDetails.type == 'pickup' )
  {this.isPickup = true;}
  else{
    this.isDrop = true;
  }

  this.pickLocation = this.taskDetails.pickuplocation;
  this.client = this.taskDetails.clientid;
  this.contact = this.taskDetails.customerphone;
  this.date = this.taskDetails.date;
  this.description = this.taskDetails.description;

  const inputDate = this.taskDetails.date;
  console.log("taskdate",this.taskDetails.date)
    this.date = this.formatCustomDate(inputDate);
   console.log('date',this.date)
    this.driverForm = this.fb.group({
      taskid:this.taskDetails.id,
      name: this.client,
      pickupLocation: this.pickLocation,
      contact:this.contact,
      date: [''],
      status: ['assigned'],
      description:this.description,
    });

    this.taskid=this.taskDetails.id;
    console.log(this.taskid)
const dateObject: Date = new Date(this.taskDetails.date);

 this.formattedDate =
  `${(dateObject.getUTCMonth() + 1).toString().padStart(2, '0')}/` +
  `${dateObject.getUTCDate().toString().padStart(2, '0')}/` +
  `${dateObject.getUTCFullYear()}`;

console.log(this.formattedDate);
  }
  ngAfterViewInit() {
    console.log('Input Field:', this.inputField.nativeElement);
    this.autocomplete = new google.maps.places.Autocomplete(this.inputField.nativeElement);
    this.autocomplete.addListener('place_changed', () => {
      const place: any = this.autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        this.lat = place.geometry.location.lat();
        this.long = place.geometry.location.lng();
        this.pickLocation = place.formatted_address;

        if (!this.map) {
          this.map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: this.lat, lng: this.long },
            zoom: 15
          });
        }
        const myLatlng = new google.maps.LatLng(this.lat, this.long);

        this.map.setCenter(myLatlng);
      }
    });
}

  formatCustomDate(dateString: string): string {
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

update(){

  const inputDate = new Date(this.driverForm.value.date);

  // Set the time to midnight
  inputDate.setHours(0, 0, 0, 0);
  
  // Convert to ISO 8601 format with the desired time offset
  const isoStringWithOffset = inputDate.toISOString().replace('Z', '+00:00');
  
  console.log(isoStringWithOffset);
    console.log('updatedetails=>',this.driverForm.value.status,this.driverForm.value.contact,
      this.driverForm.value.date,this.driverForm.value.pickupLocation,
      this.driverForm.value.description)
      this.taskDetails.status = this.driverForm.value.status;
      this.taskDetails.pickuplocation = this.driverForm.value.pickupLocation;
      // this.taskDetails.date = this.driverForm.value.isoStringWithOffset;
      this.taskDetails.customerphone = this.driverForm.value.contact;
      this.taskDetails.description = this.driverForm.value.description;
    
      this.commonService.putRequest(`traccartasks/${this.taskid}`, this.taskDetails)
      .then((resp: any) => {
        if (resp?.status) {
      
          this.commonService.commonModel.next(false);
          Swal.fire({
            icon: "success",
            title: `Task ${this.driverForm.value.taskid} updated`,
            showConfirmButton: false,
            timer: 1500,
          });        
        }      
      }, (err) => {
        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          showConfirmButton: false,
          timer: 1500,
        });
      });
this.closeModal()
  }

}
